import { fetchCurrentUserData } from "@/util/customFetch";
import { BACKEND_API_PLACEHOLDER } from '@/../environment.config'

/**
 * Get all conversations for a user (list of chat partners with last message preview).
 */
export async function getConversations(userId) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/messages/conversations/${userId}`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

/**
 * Get all contactable users (active, non-superuser) for starting new conversations.
 */
export async function getContacts(userId) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/messages/contacts/${userId}`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

/**
 * Get paginated messages between two users (newest first).
 */
export async function getMessages(userId, otherUserId, limit = 50, offset = 0) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/messages/${userId}/${otherUserId}?limit=${limit}&offset=${offset}`
  return fetch(url, {
    method: 'GET',
    headers: tokenData,
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

/**
 * Send a direct message to another user.
 */
export async function sendMessage(senderId, recipientId, content) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/messages/`
  return fetch(url, {
    method: 'POST',
    headers: { ...tokenData, 'Content-Type': 'application/json' },
    body: JSON.stringify({ sender_id: senderId, recipient_id: recipientId, content })
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}

/**
 * Mark all messages from a sender as read for the current user.
 */
export async function markMessagesRead(userId, senderId) {
  let tokenData = await fetchCurrentUserData()
  let url = BACKEND_API_PLACEHOLDER + `/api/v1/messages/read`
  return fetch(url, {
    method: 'PUT',
    headers: { ...tokenData, 'Content-Type': 'application/json' },
    body: JSON.stringify({ user_id: userId, sender_id: senderId })
  })
    .then(res => res.json()
      .then(data => { return data })
    )
}
